import React, { useState } from 'react'
import classNames from 'classnames'
import InputWrapper from './inputWrapper'
import ShowPasswordIcon from '../assets/icons/showPassWord.svg'
import HiddePassWord from '../assets/icons/NoShowPassWord.svg'

const Input = ({
  type,
  iconLeft,
  error,
  iconRight,
  label,
  handleError = true,
  textarea = false,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const inputHeight = 'h-12 2xl:h-12'

  const inputClasses = classNames(
    `w-full	border rounded-[16px] pl-4 h-[56px] focus:outline-none placeholder-[#D1D1FF]  }`,
    'text-base font-regular border-blue-80 bg-white active:bg-white',
    textarea ? 'resize-none' : inputHeight,
    error && `border-[#DC143C] border focus:border-[#DC143C]`,
    iconLeft && 'pl-16',
  )

  return (
    <InputWrapper
    
      error={error}
      iconRight={iconRight}
      iconLeft={iconLeft}
      label={label}
      handleError={handleError}
      classes={{ iconRight: textarea ? `top-0 ${inputHeight}` : undefined }}
    >
      {textarea ? (
        <textarea className={inputClasses} {...rest} />
      ) : (
        <input
          className={inputClasses}
          type={type === 'password' && showPassword ? 'text' : type}
          {...rest}
        />
      )}
      {type === 'password' && (
        <div
          className="absolute inset-y-0 right-5 flex items-center justify-center "
          onClick={() => setShowPassword(!showPassword)}
        > 
            <img src={showPassword ? ShowPasswordIcon : HiddePassWord} alt='PasswordIcon'/>
           
        </div>
      )}
    </InputWrapper>
  )
}

export default Input
